module.exports = __webpack_public_path__ + "img/Icon_Most_Winning.2ed171cf.png";